'use strict';

/*
 * @noflow - get/set properties not yet supported by flow. also `...require(x)` is broken #6560135
 */

/* eslint global-require: 0 */

module.exports = {
  // Core
  get createNavigationContainer() {
    return require('./createNavigationContainer').default;
  },
  get StateUtils() {
    return require('./StateUtils').default;
  },
  get addNavigationHelpers() {
    return require('./addNavigationHelpers').default;
  },
  get NavigationActions() {
    return require('./NavigationActions').default;
  },

  // Navigators
  get createNavigator() {
    return require('./navigators/createNavigator').default;
  },

  // Routers
  get StackRouter() {
    return require('./routers/StackRouter').default;
  },
  get TabRouter() {
    return require('./routers/TabRouter').default;
  },

  // HOCs
  get withNavigation() {
    return require('./views/withNavigation').default;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-navigation/lib/react-navigation.web.js
// module id = 7
// module chunks = 0